module.exports = __webpack_public_path__ + "img/ed267c0.png";